import React from 'react';
import { createRoot } from 'react-dom/client';

import dayjs from 'dayjs';
import 'dayjs/locale/ru';

import { Router } from '@project/routes';
import { RootStore } from '@project/store';

import { ConfigProvider } from 'antd';
import ruRU from 'antd/lib/locale/ru_RU';

dayjs.locale('ru');

import '@assets/scss/index.scss';

export const StoreContext = React.createContext<RootStore | undefined>(
  undefined,
);

const container = document.getElementById('app');
const root = createRoot(container!);
root.render(
  <React.StrictMode>
    <ConfigProvider
      locale={ruRU}
      theme={{
        token: {
          fontFamily: '"Golos", sans-serif',
        },
        components: {
          Button: {
            fontFamily: 'Golos UI',
          },
          Form: {
            fontFamily: 'Golos',
            labelFontSize: 18,
          },
          Image: {},
        },
      }}
    >
      <Router />
    </ConfigProvider>
  </React.StrictMode>,
);
